import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import baseUrl from "../../baseUrl";

// Ъ13 (03.10.2026) — съгласието при първото отваряне на публичен линк.
//
// Поискано от възложителя: човекът да види КРАТЪК текст какво му се показва,
// къде се съхранява и че линкът е личен, и да го приеме веднъж. Приемането се
// записва на сървъра (кой линк, кога, коя версия на текста) — това е следата,
// че условията са били показани и приети.
//
// Версията стои тук, до самия текст. Промени ли се текстът, вдигни я и
// съгласието се иска наново — иначе записът „приел е" би се отнасял за текст,
// който човекът никога не е виждал.
export const CONSENT_VERSION = "1";

// Устройството се разпознава по случайно число, измислено тук. Няма име, няма
// телефон — служи само да не изскача прозорецът при всяко отваряне.
const устройство = () => {
    const ключ = "p4-device";
    try {
        let id = localStorage.getItem(ключ);
        if (!id) {
            id = (crypto.randomUUID && crypto.randomUUID()) ||
                String(Date.now()) + Math.random().toString(36).slice(2);
            localStorage.setItem(ключ, id);
        }
        return id;
    } catch (_) {
        // Браузър без достъп до паметта (частен прозорец): прозорецът ще се
        // показва всеки път, но страницата работи.
        return "";
    }
};

export const ConsentGate = ({token, companyName, children}) => {
    // null = още не знаем; true/false = прието или не
    const [прието, setПрието] = useState(null);
    const [записва, setЗаписва] = useState(false);
    const [грешка, setГрешка] = useState("");
    const [id] = useState(устройство);

    const ключЛокално = `p4-consent-${token}`;

    useEffect(() => {
        let отменено = false;
        // Паметта на устройството отговаря веднага — без нея при всяко отваряне
        // би примигвал прозорец, докато сървърът отговори.
        try {
            if (localStorage.getItem(ключЛокално) === CONSENT_VERSION) {
                setПрието(true);
                return;
            }
        } catch (_) { /* няма достъп до паметта — пита се сървърът */ }

        if (!id) {
            setПрието(false);
            return;
        }
        fetch(`${baseUrl()}/public/${token}/consent?device=${encodeURIComponent(id)}` +
              `&version=${CONSENT_VERSION}`)
            .then(r => (r.ok ? r.json() : {accepted: false}))
            .then(d => {
                if (отменено) return;
                setПрието(!!d.accepted);
                if (d.accepted) {
                    try {
                        localStorage.setItem(ключЛокално, CONSENT_VERSION);
                    } catch (_) { /* без памет — ще пита пак */ }
                }
            })
            .catch(() => { if (!отменено) setПрието(false); });
        return () => { отменено = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const приеми = async () => {
        setЗаписва(true);
        setГрешка("");
        try {
            const res = await fetch(`${baseUrl()}/public/${token}/consent`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({device: id, version: CONSENT_VERSION}),
            });
            if (!res.ok) throw new Error("не се записа");
            try {
                localStorage.setItem(ключЛокално, CONSENT_VERSION);
            } catch (_) { /* без памет — ще пита пак при следващото отваряне */ }
            setПрието(true);
        } catch (_) {
            setГрешка("Нещо се обърка. Проверете връзката и опитайте пак.");
        } finally {
            setЗаписва(false);
        }
    };

    // Докато не знаем — нищо (мигване на прозореца е по-лошо от кратко чакане).
    if (прието === null) return null;
    if (прието) return children;

    return (
        <div style={{maxWidth: "720px", margin: "0 auto", padding: "24px 16px"}}>
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title" style={{color: "var(--app-gold)"}}>
                        Преди да продължите
                    </h5>

                    <p className="mb-2">
                        Тази страница показва данните за земеделските площи на{" "}
                        <strong>{companyName || "вашата фирма"}</strong> — декларирани площи,
                        доброволни замени, изчертани масиви и приложените карти по землища.
                        Данните въвежда и поддържа администраторът, който ви е изпратил линка.
                    </p>

                    <ul className="mb-3" style={{fontSize: "0.95rem"}}>
                        <li>
                            През този адрес се виждат <strong>само данни, отнасящи се до вас</strong>.
                            Чужди фирми и техните площи не се показват.
                        </li>
                        <li>
                            Връзката е <strong>шифрована</strong> (HTTPS). Линкът е личен —
                            не го препращайте; всеки, който го има, вижда същото.
                        </li>
                        <li>
                            Данните се съхраняват и обработват на сървър в Европейския съюз
                            (Франкфурт), нает от <strong>DigitalOcean, LLC</strong> — доставчикът
                            на хостинга.
                        </li>
                        <li>
                            На вашето устройство се пази само кои землища и съобщения вече сте
                            виждали, за да личи какво е ново. Това не е лична информация и
                            изчезва при изчистване на данните на браузъра.
                        </li>
                        <li>
                            Ако сам разрешите известия, съобщенията се доставят през услугата
                            за известия на Google или Apple. Съдържанието е шифровано и те не
                            го четат. Разрешението се дава отделно и може да се оттегли от
                            настройките на телефона.
                        </li>
                    </ul>

                    <p className="mb-3">
                        С натискането на „Съгласен съм" потвърждавате, че сте запознати с
                        горното и сте съгласни данните ви да се пренасят през интернет и да
                        се съхраняват при посочения доставчик. Записваме датата и часа на
                        съгласието. Подробните{" "}
                        <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer">
                            Общи условия
                        </Link>{" "}
                        и{" "}
                        <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
                            Политика за поверителност
                        </Link>{" "}
                        са достъпни по всяко време.
                    </p>

                    {грешка && <div className="alert alert-warning py-2">{грешка}</div>}

                    <button className="btn btn-success" onClick={приеми} disabled={записва}>
                        {записва ? "Момент…" : "Съгласен съм"}
                    </button>
                    <div className="text-muted mt-2" style={{fontSize: "0.85rem"}}>
                        Ако не сте съгласни, просто затворете страницата. Въпроси — към
                        администратора, който ви е изпратил линка.
                    </div>
                </div>
            </div>
        </div>
    );
};
